import { Auth0Provider } from '@auth0/auth0-react';
import { env, hasAuth0Config } from '../../shared/config/env';

const authEnabled = hasAuth0Config();

export function AuthProvider({ children }) {
  if (!authEnabled) {
    return children;
  }

  const { domain, clientId, audience } = env.auth0;
  const authorizationParams = {
    redirect_uri: window.location.origin,
    scope: 'openid profile email',
  };

  if (audience) {
    authorizationParams.audience = audience;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={authorizationParams}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
}
